import { Component, PLATFORM_ID, Inject } from '@angular/core';
// import { isPlatformBrowser } from '@angular/common';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { map, delay, withLatestFrom } from 'rxjs/operators';
// import { TranslateService } from '@ngx-translate/core';
import { DOCUMENT } from '@angular/common';
import { LayoutService } from './shared/services/layout.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  
  // For Progressbar
  loaders = this.loader.progress$.pipe(
    delay(1000),
    withLatestFrom(this.loader.progress$),
    map(v => v[1]),
  );
  
  constructor( public layoutService : LayoutService,@Inject(PLATFORM_ID) private platformId: Object,private loader: LoadingBarService,@Inject(DOCUMENT) public document: Document ) {
  }
  ngOnInit(): void {
  
    // for change url icon dyanamic for index.html
    this.setFavicon(this.layoutService?.displayDefaultCompanyIcon);
  }

  setFavicon(url: string | undefined): void {
    const favicon = this.document.querySelector("link[rel*='icon']") as HTMLLinkElement;
    if (favicon) {
      favicon.href = url;
    }
  }
}
